import React from 'react'

import { ConfirmationDialog } from '@front/squirtle'

const Popup = ({ onConfirmCancel }) =>
  <ConfirmationDialog
    name={'confirmation_cancel'}
    maxWidth={'lg'}
    onConfirm={onConfirmCancel}
  />

export default React.memo(Popup)
